module.exports = "<div class=\"row top-section-container\">\r\n    <div class=\"col-md-6\">\r\n      <h2> {{'JOB_SCHEDULER_CONFIG' | i18next}}</h2>\r\n      <p><i class=\"fa fa-info-circle top-info-icon\"></i></p>\r\n    </div>\r\n  </div>\r\n  \r\n  <div class=\"row table-container\">\r\n  \r\n    <div class=\"col-md-12\">\r\n        \r\n    </div>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/outputs/Schedule/Configuration/jobScheduleConfiguration.component.html
// module id = ../../../../../src/app/private/outputs/Schedule/Configuration/jobScheduleConfiguration.component.html
// module chunks = main